const translateReuse = {
  na: '不适用',
};

export default translateReuse;
